// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  
  #spinner {
    display: block;
    width: 200px;  
  }
  
 .spinner-container{

  display: flex;
  justify-content: center;
 }

 .ods-image img{
  max-width: 11rem;
  height: auto;
  border-radius: 5%;

 }
 
 /* CSS PARA DOCUMENT */
 .ods-image-document img{
  max-width: 7rem;
  height: auto;
  border-radius: 5%;
 }

 #spinner-document {
  display: block;
  width: 7rem;  
}
  `, "",{"version":3,"sources":["webpack://./src/styles/Porcentage.css"],"names":[],"mappings":";EACE;IACE,cAAc;IACd,YAAY;EACd;;CAED;;EAEC,aAAa;EACb,uBAAuB;CACxB;;CAEA;EACC,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;;CAElB;;CAEA,sBAAsB;CACtB;EACC,eAAe;EACf,YAAY;EACZ,iBAAiB;CAClB;;CAEA;EACC,cAAc;EACd,WAAW;AACb","sourcesContent":["  \n  #spinner {\n    display: block;\n    width: 200px;  \n  }\n  \n .spinner-container{\n\n  display: flex;\n  justify-content: center;\n }\n\n .ods-image img{\n  max-width: 11rem;\n  height: auto;\n  border-radius: 5%;\n\n }\n \n /* CSS PARA DOCUMENT */\n .ods-image-document img{\n  max-width: 7rem;\n  height: auto;\n  border-radius: 5%;\n }\n\n #spinner-document {\n  display: block;\n  width: 7rem;  \n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
